import Vue from 'vue';
import $ from 'jquery';
import waves from './waves';
import template from './template.html';


export default Vue.component('pre-loader', {
  template: template,
  data: function () {
    return {};
  },
  watch: {
    hasPreloadedHalf () {
      window.TweenMax.fromTo($('.pre-loader__text'), 7,{scale: 0.7, opacity: 0}, {scale: 1, opacity: 1, ease: window.Linear.easeOut});
    }
  },
  mounted () {
    if(!this.hasPreloaded) {
      waves(this.$el, this.$store).init();
    } else {
      $(this.$el).fadeOut(1000);
    }
  },
  computed: {
    hasPreloaded () {
      return this.$store.state.ui.hasPreloaded;
    },
    hasPreloadedHalf () {
      return this.$store.state.ui.hasPreloadedHalf;
    }
  }
});



// WEBPACK FOOTER //
// ./C:/projects/okinawa/be-okinawa/src/js/components/pre-loader/main.js